/**
 * Harness identifiers — the engines that can drive an agent loop.
 *
 * Additive by design: a new arm appends an id here.
 *
 * 'claude_code' (2026-09-14) is the unmodified Claude Code CLI running in the
 * user's own box on the user's own Claude plan. It is deliberately a NEW id: the
 * legacy 'claude' id is on historical task rows that must keep launching native.
 *
 * 'codex' (2026-10-06, engines T3) is the unmodified Codex CLI (`codex app-server`)
 * running in the user's own box on the user's own ChatGPT plan. Same shape as
 * 'claude_code': a plan engine, never a native transport.
 */
export const HARNESS_IDS = ['claude', 'openai', 'native', 'openai_responses', 'claude_code', 'codex'] as const;

export type HarnessId = (typeof HARNESS_IDS)[number];

export function isHarnessId(value: unknown): value is HarnessId {
  return typeof value === 'string' && (HARNESS_IDS as readonly string[]).includes(value);
}
